import * as React from "react";
import { cn } from "@/utils/tailwind";

type InputProps = React.ComponentProps<"input"> & {
  dataTest?: string;
};

function Input({ className, type, dataTest, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      data-test={dataTest}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground border-input selection:bg-primary selection:text-primary-foreground bg-background disabled:bg-card h-12 w-full min-w-0 rounded-[6px] border px-[17px] py-2.5 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 vtac:aria-invalid:ring-destructive/40 aria-invalid:border-destructive vtac:disabled:border-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
